import { render, staticRenderFns } from "./finisher.vue?vue&type=template&id=60523b1e&"
import script from "./finisher.vue?vue&type=script&lang=js&"
export * from "./finisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports